module.exports = __webpack_public_path__ + "img/Speaker=Harley Finkelstein.3582e2ff.png";